"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getTextAlign = void 0;

var _text = require("../../constants/text");

var getTextAlign = function getTextAlign(alignment) {
  var isRTL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isRTL) {
    switch (alignment) {
      case _text.TEXT_ALIGNMENT.LEFT:
        return 'right';

      case _text.TEXT_ALIGNMENT.CENTER:
        return 'center';

      case _text.TEXT_ALIGNMENT.RIGHT:
        return 'left';

      default:
        return 'left';
    }
  }

  switch (alignment) {
    case _text.TEXT_ALIGNMENT.LEFT:
      return 'left';

    case _text.TEXT_ALIGNMENT.CENTER:
      return 'center';

    case _text.TEXT_ALIGNMENT.RIGHT:
      return 'right';

    default:
      return 'left';
  }
};

exports.getTextAlign = getTextAlign;
var _default = getTextAlign;
exports["default"] = _default;